export default __webpack_public_path__ + "static/KentBolton-4a48cc1622bee3059b0634ac71d702d9.png";